import { useEffect, useRef } from "react";
import siteData from "../data/siteData.json";

function useCarouselClones() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    let items = document.querySelectorAll(
      ".completed-projects .carousel .carousel-item"
    );
    items.forEach((el) => {
      const minPerSlide = 4;
      let next = el.nextElementSibling;
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          // wrap carousel by using first child
          next = items[0];
        }
        let cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  }, []);
}

function useModalClose() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    // Get the modal
    const modal = document.getElementById("id01");
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    };
  }, []);
}

function OngoingProjects() {
  useCarouselClones();
  useModalClose();

  const { ongoingProjects } = siteData;

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={siteData.heroBanner}
                className="d-block w-100"
                alt="..."
              />
            </div>
          </div>
        </div>
      </header>
      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>OUR PROJECTS</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="project pt-5 pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="title">
                <h1>Ongoing Projects</h1>
              </div>
            </div>
            {ongoingProjects.map((project) => (
              <div className="col-md-4 mt-2 mb-3" key={project.id}>
                <div className="project-mas hover-shadow">
                  <div className="image-effect-one">
                    <img src={project.image} alt={project.name} />
                    <span
                      className={`badge-status ${project.badgeClass}`}
                    >
                      {project.badge}
                    </span>
                    <span
                      className="map-icon-btn"
                      data-bs-toggle="modal"
                      data-bs-target={`#${project.mapModalId}`}
                    >
                      <i className="fa fa-map-marker"></i>
                    </span>
                  </div>
                  <div className="project-info">
                    <h4>{project.name}</h4>
                    <p className="project-desc">{project.desc}</p>
                    <div className="project-details">
                      <div className="detail-item">
                        <i className={`fa ${project.configIcon}`}></i>{" "}
                        <strong>{project.config}</strong>
                      </div>
                      <div className="detail-item">
                        <i className="fa fa-map-marker"></i>{" "}
                        <strong>{project.location}</strong>
                      </div>
                      <div className="detail-item">
                        <i className="fa fa-calendar"></i>{" "}
                        <strong>{project.possession}</strong>
                      </div>
                    </div>
                    <div
                      className="rera-info"
                      style={
                        project.ocPdf
                          ? {
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }
                          : undefined
                      }
                    >
                      <span
                        className="rera-badge"
                        style={project.ocPdf ? { flex: "1", textAlign: "center" } : undefined}
                      >
                        RERA: {project.rera}
                      </span>
                      {project.ocPdf && (
                        <button
                          className="btn-visit"
                          style={{
                            flex: "1",
                            padding: "4px 10px",
                            fontSize: "11px",
                            margin: "0",
                          }}
                          onClick={() => window.open(project.ocPdf, "_blank")}
                        >
                          <i className="fa fa-download" style={{ color: "#fff" }}></i>{" "}
                          OC UNDERTAKING
                        </button>
                      )}
                    </div>
                    <div className="project-cta">
                      <button className="btn-enquire">
                        <a className="read">ENQUIRE NOW</a>
                      </button>
                      {project.downloads ? (
                        <button
                          className="btn-visit"
                          data-bs-toggle="modal"
                          data-bs-target={`#${project.downloadModalId}`}
                        >
                          <i className="fa fa-download"></i> DOWNLOAD
                        </button>
                      ) : (
                        <button className="btn-visit">
                          <a
                            href="/pdf/Brochure.pdf"
                            target="_blank"
                            className="read"
                          >
                            <i className="fa fa-download"></i> DOWNLOAD
                          </a>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {ongoingProjects
        .filter((project) => project.downloads)
        .map((project) => (
          <div
            className="modal fade map-modal"
            id={project.downloadModalId}
            tabIndex="-1"
            aria-hidden="true"
            key={project.downloadModalId}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div
                className="modal-content"
                style={{ borderRadius: "10px", overflow: "hidden" }}
              >
                <div className="modal-header" style={{ padding: "20px 25px" }}>
                  <h5 className="modal-title" style={{ fontSize: "18px" }}>
                    {project.downloadTitle}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "30px 25px",
                  }}
                >
                  {project.downloads.map((download) => (
                    <button
                      className="btn-visit"
                      style={{
                        flex: "1",
                        padding: "20px",
                        fontSize: "15px",
                        fontWeight: "600",
                        backgroundColor: "#333",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        letterSpacing: "0.5px",
                      }}
                      key={download.label}
                      onClick={() =>
                        window.open(download.pdf, "_blank")
                      }
                    >
                      <i className="fa fa-download"></i> {download.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}

      {ongoingProjects.map((project) => (
        <div
          className="modal fade map-modal"
          id={project.mapModalId}
          tabIndex="-1"
          aria-hidden="true"
          key={project.mapModalId}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{project.mapTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={project.mapEmbed}
                  width="100%"
                  height="450"
                  style={{ border: "0" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${project.name} Location Map`}
                ></iframe>
                <div className="location-info">
                  <p>
                    <i className="fa fa-map-marker"></i> <strong>Address:</strong>{" "}
                    {project.mapAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default OngoingProjects;